import { Link } from 'react-router-dom';
import { Lock } from 'lucide-react';

export default function Footer() {
  return (
    <footer className="bg-gray-800 text-white py-8">
      <div className="container mx-auto px-6">
        <div className="flex flex-col md:flex-row justify-between">
          <div className="mb-6 md:mb-0">
            <Link to="/" className="text-xl font-bold flex items-center">
              <Lock size={20} className="mr-2 text-gray-500" />
              safeVibe
            </Link>
            <p className="mt-2 text-gray-400 text-sm">
              Security Scanner for Modern Web Apps
            </p>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-3 gap-8">
            <div>
              <h3 className="text-sm font-semibold mb-4 uppercase">Explore</h3>
              <ul className="space-y-2">
                <li><Link to="/scan-upload" className="text-gray-400 hover:text-white">Start Scan</Link></li>
                <li><Link to="/upgrade" className="text-gray-400 hover:text-white">Upgrade to Pro</Link></li>
              </ul>
            </div>
            <div>
              <h3 className="text-sm font-semibold mb-4 uppercase">Legal</h3>
              <ul className="space-y-2">
                <li><Link to="/privacy" className="text-gray-400 hover:text-white">Privacy Policy</Link></li>
                <li><Link to="/terms" className="text-gray-400 hover:text-white">Terms of Service</Link></li>
                <li><Link to="/cookies" className="text-gray-400 hover:text-white">Cookies</Link></li>
              </ul>
            </div>
            <div>
              <h3 className="text-sm font-semibold mb-4 uppercase">Contact</h3>
              <ul className="space-y-2">
                <li><a href="mailto:hello@safevibe.dev" className="text-gray-400 hover:text-white">hello@safevibe.dev</a></li>
              </ul>
            </div>
          </div>
        </div>
        <div className="border-t border-gray-700 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm">© 2025 safeVibe. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
} 